import { BaseListViewStore, UsernameCellData, DateTimeCellData, HistoryPropertyCellData } from 'core/stores';
import { action } from 'mobx';
import { TableMethodInject } from 'core/components';
import { historyLogSource } from 'common/constants';
import { translate } from 'core/utils';
import { OrderStore } from 'modules/order/stores';
import _ from 'lodash';

class MarketplaceOrderHistoryLogViewStore extends BaseListViewStore {
	order = null;

	constructor(rootStore) {
		super(rootStore, {
			listStore: new OrderStore(rootStore),
			queryParams: { embed: ['user', 'marketplaceOrder'] },
			findFunction: 'findMarketplaceOrderHistoryLog',
			routes: {
				list: () => this.rootStore.routerStore.goTo('master.app.main.order.marketplace.list'),
			},
			tableData: {
				columns: [
					{
						key: 'user.displayName',
						dataCell: UsernameCellData,
						title: 'ORDERVIEW.HISTORYLOG.LIST.UPDATEDBY',
						width: 200,
						sortable: false,
					},
					{
						key: 'dateCreated',
						title: 'ORDERVIEW.HISTORYLOG.LIST.DATECREATED',
						dataCell: DateTimeCellData,
						sortable: false,
						dateFormat: 'LLL',
						useLocalTime: true,
					},
					{
						key: 'userAction',
						title: 'ORDERVIEW.HISTORYLOG.LIST.USERACTION',
						row: TableMethodInject,
						sortable: false,
						width: 200,
						extra: ({ item, column }) => translate('ORDERVIEW.HISTORYLOG.LIST.ACTIONS.' + item[column.key]),
					},
					{
						key: 'name',
						title: 'ORDERVIEW.HISTORYLOG.LIST.PROPERTY',
						dataCell: HistoryPropertyCellData,
						sortable: false,
						width: 400,
					},
					{
						key: 'initialValue',
						title: 'ORDERVIEW.HISTORYLOG.LIST.OLDVALUE',
						dataCell: HistoryPropertyCellData,
						sortable: false,
						width: 300,
					},
					{
						key: 'newValue',
						title: 'ORDERVIEW.HISTORYLOG.LIST.NEWVALUE',
						dataCell: HistoryPropertyCellData,
						sortable: false,
						width: 300,
					},
				],
				actions: {},
				sortObject: [],
			},
		});
		this.order = rootStore.marketplaceOrderDetailViewStore.order;
		this.queryUtility.initialize(this.findMarketplaceOrderHistoryLog);
	}

	@action.bound async findMarketplaceOrderHistoryLog() {
		this.suspend();
		let filter = this.queryUtility.filter;
		filter.source = String(historyLogSource.marketplaceOrder);
		if (this.rootStore.routerStore.routerState.params.id) {
			filter.itemId = String(this.rootStore.routerStore.routerState.params.id);
		}
		if (filter.orderBy === null && filter.orderDirection === null) {
			filter.orderBy = 'dateCreated';
			filter.orderDirection = 'desc';
		}
		await this.listStore.findMarketplaceOrderHistoryLog(filter);
		if (this.listStore.response.item.length === 0 && this.listStore.response.page !== 1) {
			await this.queryUtility.changePage(1);
		}
		this.queryUtility.handleResponse(this.listStore.response);
		// When history log data is rendered, go back to previous route (reset to initial route when modal was opened).
		this.rootStore.historyAdapter.goBack();
		this.resume();
	}
}

export default MarketplaceOrderHistoryLogViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/MarketplaceOrderHistoryLogViewStore.js